import { Component } from '@angular/core';

@Component({
    selector: 'app-add-button',
    templateUrl: './add-button.component.html',
    styleUrls: ['./add-button.component.css'],
    standalone: false
})
export class AddButtonComponent {}
